document.addEventListener("DOMContentLoaded", (event) => {
  const transferBasketForm = document.getElementById("TransferBasketForm");
  const singleProductButtons = document.querySelectorAll(".single-product");
  const hideProductElements = document.querySelectorAll(".hide-card");
  // Select the "Base" button and simulate a click to activate it
  const buttons = document.querySelectorAll(".bundler__size__selector button");
  const savingsText = document.querySelector(".savings-text");
  const addToBasketButtons = document.querySelectorAll(".button-basket");
  const existingSubmitButton = document
    .getElementById("TransferBasketForm")
    ?.querySelector('input[type="submit"]');

  let basket = {};
  let newForm;
  newForm = existingSubmitButton
    ? transferBasketForm
    : document.createElement("form");
  newForm.id = "TransferBasketForm";
  newForm.method = "post";
  newForm.action = "/cart/add";
  const basketFromStorage = JSON.parse(localStorage.getItem("basket"));
  if (basketFromStorage && Object.keys(basketFromStorage).length > 0) {
    // If the basket in localStorage is not empty, clear it and the associated form inputs
    basket = {};
    localStorage.removeItem("basket");

    // Remove any existing form inputs from the transfer basket form
    const hiddenInputs = transferBasketForm.querySelectorAll(
      'input[type="hidden"]'
    );
    hiddenInputs.forEach((input) => input.remove());

    // Reset the state of the "Add to Basket" buttons
    addToBasketButtons.forEach((button) => {
      const variantIdInput =
        button.parentElement.querySelector('input[name="id"]');
      if (variantIdInput) {
        updateButtonState(button, variantIdInput.value, false);
      }
    });
  } else {
    // If the basket is empty, initialize it as an empty object
    basket = {};
  }
  // Create priceDisplay element once, outside any functions

  let priceDisplay = document.createElement("div");
  priceDisplay.id = "totalPriceDisplay";
  if (transferBasketForm) {
    const existingSubmitButton = transferBasketForm.querySelector(
      'input[type="submit"]'
    );
    if (existingSubmitButton) {
      existingSubmitButton.parentNode.insertBefore(
        priceDisplay,
        existingSubmitButton
      );
    } else {
      transferBasketForm.appendChild(priceDisplay); // Append if no submit button
    }
  } else {
    console.error("TransferBasketForm not found! Please check your HTML.");
  }
  // *** 1. Bundle Selection Logic ***
  function handleBundleButtonClick(button) {
    buttons.forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");

    const info = button.getAttribute("data-info");
    savingsText.textContent = `${info}`;

    const selectedBundleIndex = Array.from(buttons).indexOf(button);
    if (selectedBundleIndex === 0) {
      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth' 
      });
    }

    // Update single product button states based on bundle index
    singleProductButtons[0].disabled = selectedBundleIndex === 0;
    singleProductButtons[1].disabled = selectedBundleIndex !== 2; // Enable only for "Full Collection"

    hideProductElements.forEach((element, index) => {
      if (index === 0) {
        // Show the first element only if selectedBundleIndex is 1 or 2
        element.style.display = [1, 2].includes(selectedBundleIndex)
          ? "block"
          : "none";
      } else if (index === 1) {
        // Show the second element only if selectedBundleIndex is 2
        element.style.display = selectedBundleIndex === 2 ? "block" : "none";
      }
    });

    // Remove form inputs if single product button is disabled
    singleProductButtons.forEach((btn) => {
      if (btn.disabled) {
        const variantIdInput = btn.parentElement.querySelector(
          ".product-variant-id"
        );
        if (variantIdInput) {
          const variantId = variantIdInput.value;
          removeFormInputsForButton(btn, variantId);
          delete basket[variantId]; // Remove from the basket object
          localStorage.setItem("basket", JSON.stringify(basket)); // Update localStorage
          updateButtonState(btn, variantId, false); // Update button state
        }
      }
    });

    console.log("Basket after bundle selection:", basket);
    console.log("Submit button visibility updated.");
    updateSubmitButtonVisibility();
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => handleBundleButtonClick(button));
  });

  // *** 2. Initial "Base" Button Click Simulation ***
  handleBundleButtonClick(buttons[0]); // Call the function to set up the initial state
  function scrollToNextBundleItem(currentBundleItem, scrollOffset = 500) {
    const nextBundleItem = currentBundleItem.nextElementSibling;

    if (nextBundleItem && nextBundleItem.classList.contains("bundle-item")) {
      nextBundleItem.scrollIntoView({ behavior: "smooth" });
      window.scrollBy(0, scrollOffset); // Adjust the offset as needed
    }
  }
  function handleBasketButtonClick(button, variantId, price, currentBundleItem) {
    // Find the parent <ul> element
    const parentUl = button.closest("ul");
  
    // Main event handling logic
    button.addEventListener("click", () => {
      console.log("Add/Remove button clicked for variant:", variantId);
  
      if (basket[variantId]) {
        console.log("Removing from basket:", variantId);
        delete basket[variantId];
        removeFormInputsForButton(button, variantId);
  
        if (parentUl) {
          const buttonsInSameUl = parentUl.querySelectorAll(".button-basket");
          buttonsInSameUl.forEach((otherButton) => {
            otherButton.disabled = false;
            updateButtonState(otherButton, variantId, false); 
          });
        }
      } else {
        console.log("Adding to basket:", variantId);
        basket[variantId] = { quantity: 1, price };
        addFormInputsForButton(button, variantId);
        updateButtonState(button, variantId, true);
  
        if (parentUl) {
          const buttonsInSameUl = parentUl.querySelectorAll(".button-basket");
          buttonsInSameUl.forEach((otherButton) => {
            otherButton.disabled = otherButton !== button; 
          });
        }
  
        scrollToNextBundleItem(currentBundleItem);
      }
  
      localStorage.setItem("basket", JSON.stringify(basket));
      updateSubmitButtonVisibility();
      console.log("Basket after add/remove:", basket);
    });
  }
  

  // *** 2. Add to Basket / Remove Logic ***
  addToBasketButtons.forEach((button) => {
    const price = parseFloat(button.dataset.price);
    const variantId = button.parentElement.querySelector(
      ".product-variant-id"
    ).value;
    const currentBundleItem = button.closest(".bundle-item"); // Find the current bundle item
    handleBasketButtonClick(button, variantId, price, currentBundleItem);
  });

  // Helper function to get total quantity in the basket
  function getTotalQuantity() {
    return Object.values(basket).reduce(
      (sum, item) => sum + (item.quantity || 1),
      0
    );
  }

  function updateSubmitButtonVisibility() {
    const selectedBundle = Array.from(buttons).find((btn) =>
      btn.classList.contains("active")
    );
    const totalQuantity = getTotalQuantity();
    const minItems = parseInt(selectedBundle.dataset.minItems, 10) || 0;
    const showButton = selectedBundle && totalQuantity >= minItems;

    if (!selectedBundle || Object.keys(basket).length === 0) {
      // Check for empty basket
      existingSubmitButton.style.display = "none";
      priceDisplay.style.display = "none";
      return;
    }

    if (showButton) {
      const discountPercentage = parseFloat(selectedBundle.dataset.discount);
      const totalPrice = Object.values(basket).reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );
      const discountedPrice =
        totalPrice - totalPrice * (discountPercentage / 100);

      priceDisplay.innerHTML = `
            <div class="bundle-info">
              <span class="bundle-price-label">Bundle Price:</span>
              <span class="total-quantity">(${totalQuantity} item${
        // Use totalQuantity here
        totalQuantity !== 1 ? "s" : ""
      })</span>
            </div>
            <span class="original-price">£${totalPrice.toFixed(2)}</span>
            ${
              discountPercentage > 0
                ? `<span> £${discountedPrice.toFixed(2)}</span>`
                : ""
            }
          `;

      priceDisplay.style.display = "block";
    } else {
      priceDisplay.innerHTML = "Add items to see bundle pricing.";
      priceDisplay.style.display = "block";
    }

    existingSubmitButton.style.display = showButton ? "block" : "none";
    console.log("Updating submit button visibility...");
    console.log("Selected bundle:", selectedBundle?.textContent);
    console.log("Number of items in basket:", totalQuantity); // Log totalQuantity
    console.log("Required items:", minItems);
    console.log("Show button?", showButton);
  }

  // Helper function to update button state based on whether it's in the basket
  function updateButtonState(button, variantId) {
    button.textContent = basket[variantId] ? "Remove" : "Add to Basket";

    button.classList.toggle("active", !!basket[variantId]); // Toggle the active class
  }

  // Helper function (unchanged)
  function removeFormInputsForButton(button, variantId) {
    const idInputs = transferBasketForm.querySelectorAll(
      `input[type="hidden"][name="id[]"][value="${variantId}"]`
    );
    const quantityInputs = transferBasketForm.querySelectorAll(
      `input[type="hidden"][name="quantity[]"][value="${
        basket[variantId]?.quantity || 1
      }"]` // Fix for undefined quantity
    );

    idInputs.forEach((input) => input.remove());
    quantityInputs.forEach((input) => input.remove());
  }
  function addFormInputsForButton(button, variantId) {
    // Check if inputs for this variantId already exist
    const existingIdInput = newForm.querySelector(
      `input[type="hidden"][name="id[]"][value="${variantId}"]`
    );
    if (existingIdInput) {
      // If they exist, increment the quantity
      const existingQuantityInput = newForm.querySelector(
        `input[type="hidden"][name="quantity[]"][value]`
      );
      existingQuantityInput.value = parseInt(existingQuantityInput.value) + 1;
    } else {
      // If they don't exist, create new inputs
      const idInput = document.createElement("input");
      idInput.type = "hidden";
      idInput.name = "id[]";
      idInput.value = variantId;

      const quantityInput = document.createElement("input");
      quantityInput.type = "hidden";
      quantityInput.name = "quantity[]";
      // Get quantity from the basket object (or default to 1)
      quantityInput.value = basket[variantId]?.quantity || 1;

      newForm.appendChild(idInput);
      newForm.appendChild(quantityInput);
    }
  }

  // Handle "Transfer to Cart" button click
  existingSubmitButton.addEventListener("click", () => {
    // Clear the form after submission (with a slight delay for form submission to complete)
    setTimeout(() => {
      addToBasketButtons.forEach((button) => {
        const variantIdInput = button.parentElement.querySelector(
          ".product-variant-id"
        );
        const variantId = variantIdInput ? variantIdInput.value : null;

        if (variantId) {
          removeFormInputsForButton(button, variantId); // Use helper function to remove inputs and update state
        }
        updateButtonState(button, variantId, false); // Reset button state
      });
      // Select all hidden input elements
      const hiddenInputs = transferBasketForm.querySelectorAll(
        'input[type="hidden"]'
      );
      // Remove each hidden input element
      hiddenInputs.forEach((input) => input.remove());
      // Reset all Add to Basket buttons

      // Reinitialize priceDisplay
      priceDisplay.style.display = "none";
      existingSubmitButton.style.display = "none";

      // Re-trigger bundle selection logic (optional)
      handleBundleButtonClick(buttons[0]); // Reset to initial state if needed

      // Clear the basket data
      basket = {};
      localStorage.removeItem("basket");
      updateSubmitButtonVisibility();
      window.location.reload(); 
    }, 100); // Adjust delay as needed (e.g., increase if form submission is slow)
  });
});
